import styles from './index.module.sass';

const Expired = () => {
  return (
    <div className={styles.expired}>
      <h2>連線逾時</h2>
      <p>連線已逾時，請返回全國 App 重新進入服務頁面。</p>
    </div>
  );
};

export default Expired;
